import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBackArrowIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	"data-rtl-mirror": "true",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_2294_7268",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_2294_7268)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6.8 12.9998L9.7 15.8998C9.88334 16.0831 9.975 16.3165 9.975 16.5998C9.975 16.8831 9.88334 17.1165 9.7 17.2998C9.51667 17.4831 9.28334 17.5748 9 17.5748C8.71667 17.5748 8.48334 17.4831 8.3 17.2998L3.7 12.6998C3.6 12.5998 3.52917 12.4915 3.4875 12.3748C3.44584 12.2581 3.425 12.1331 3.425 11.9998C3.425 11.8665 3.44584 11.7415 3.4875 11.6248C3.52917 11.5081 3.6 11.3998 3.7 11.2998L8.3 6.6998C8.48334 6.51647 8.71667 6.4248 9 6.4248C9.28334 6.4248 9.51667 6.51647 9.7 6.6998C9.88334 6.88314 9.975 7.11647 9.975 7.3998C9.975 7.68314 9.88334 7.91647 9.7 8.0998L6.8 10.9998H20C20.2833 10.9998 20.5208 11.0956 20.7125 11.2873C20.9042 11.479 21 11.7165 21 11.9998C21 12.2831 20.9042 12.5206 20.7125 12.7123C20.5208 12.904 20.2833 12.9998 20 12.9998H6.8Z",
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgBackArrowIcon);
export default ForwardRef;
